/**
 * @voltxampere/ui — Yellow LED 5mm (Sprint 51-1 polish, dedicated variant)
 *
 * Standard 5mm yellow LED — GaAsP/AlGaInP, V_F ≈ 2.0V at 20mA.
 * Common in traffic-light demos, "warning" indicator usage.
 *
 * Engine zero-diff invariant honored — schemaType `led`.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { led } from "../led.js";
export const ledYellow5mm = {
    id: "led-yellow-5mm",
    nameTr: "LED Sarı 5mm (genel)",
    nameEn: "LED Yellow 5mm (generic)",
    shortcut: "D",
    category: "active",
    viewBox: led.viewBox,
    terminals: led.terminals,
    defaultLabel: "D",
    defaultValue: "YELLOW",
    schemaType: "led",
    defaultParams: {
        is: 1e-12,
        n: 3,
        vForward: 2.0,
        color: "yellow",
        package: "T-1¾ (5mm)",
        wavelengthNm: 590,
        luminousIntensityMcd: 90,
    },
    renderSVG: () => led.renderSVG(),
};
//# sourceMappingURL=led-yellow-5mm.js.map